import React from 'react'
import { CallbackComponent } from 'redux-oidc'
import {
    Container
} from 'reactstrap'
import View from 'components/View'
import PageTitle from 'components/PageTitle'
import SubNavigation from 'components/SubNavigation'

import userManager from 'services/UserManager'
import store from '../../store'
import router from '../../router'


class Callback extends React.Component {
    successCallback = () => {
        const state = store.getState()
        const {
            auth: {
                user: { access_token }
            }
        } = state

        sessionStorage.setItem('ARO_ADMIN_SID', access_token)

        if (store.dispatch.profile) {
            store.dispatch.profile.load()
        }

        if (store.dispatch.organisations) {
            store.dispatch.organisations.load()
        }

        if (store.dispatch.auth) {
            store.dispatch.auth.load()
        }

        router.navigate('/')
    }

    errorCallback = error => {
        console.error('errorCallback', error)
        router.navigate('/')
    }

    render() {
        return (
            <CallbackComponent
                userManager={ userManager }
                successCallback={ this.successCallback }
                errorCallback={ this.errorCallback }
            >
                <React.Fragment>
                    <SubNavigation />
                    <View>
                        <Container className="ao-dashboard">
                            <PageTitle>Login</PageTitle>
                            <p>Doorverwijzen...</p>
                        </Container>
                    </View>
                </React.Fragment>
            </CallbackComponent>
        )
    }
}

export default Callback
